export default __webpack_public_path__ + "static/media/japanDay2021Poster.1478ab22.jpg";